import {
  GET_CURRENT_USER_DATA,
  GET_CURRENT_USER_DATA_ERROR,
  UPDATE_CURRENT_USER_DATA,
  UPDATE_CURRENT_USER_DATA_ERROR,
  MANUALLY_TRIGGER_STATUS,
  UPDATE_CURRENT_DATA_PASSWORD,
  UPDATE_CURRENT_DATA_PASSWORD_ERROR,
  MANUALLY_TRIGGER_ROLE
} from "../types";

const initialState = {};

export const currentUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_USER_DATA:
      return { ...state, currentUserData: action.payload };
    case GET_CURRENT_USER_DATA_ERROR:
      return { ...state, currentUserDataError: action.payload };
    case UPDATE_CURRENT_USER_DATA:
      return {
        ...state,
        currentUserData: action.payload.data.user,
        updateCurrentUserDataStatus: action.payload.status,
        updateCurrentUserDataMessage: "Успешно сте едитовали податке профила"
      };
    case UPDATE_CURRENT_USER_DATA_ERROR:
      return {
        ...state,
        updateCurrentUserDataError: action.payload.message,
        updateCurrentUserDataStatus: action.payload.status,
        updateCurrentUserDataMessage:
          "Грешка приликом едитовања података профила, покушајте поново"
      };
    case UPDATE_CURRENT_DATA_PASSWORD:
      return {
        ...state,
        updateCurrentUserDataStatus: action.payload.status,
        updateCurrentUserDataMessage: "Успешно сте променили шифру"
      };
    case UPDATE_CURRENT_DATA_PASSWORD_ERROR:
      return { ...state, updateCurrentPasswordStatusError: action.payload };
    case MANUALLY_TRIGGER_STATUS:
      return {
        ...state,
        updateCurrentUserDataStatus: ""
      };
    case MANUALLY_TRIGGER_ROLE:
      return { ...state, currentUserData: action.payload };
    default:
      return state;
  }
};
